/**
 * Libs
 */
import { LotI, NFTI } from '@tacans/shared-marketplace-layer';
import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
import React, { useCallback } from 'react';

/**
 * Hooks
 */
import { useSidebar } from 'src/features/common/app/hooks/use-sidebar';

const BidsSideBarContainer = dynamic(() => import('../containers/bids-sidebar-container'), { ssr: false });

export const useRenderBidsSidebar = () => {
    const { t } = useTranslation(['components']);
    const { render } = useSidebar();

    return useCallback(
        (nft: NFTI, lot: LotI) => {
            render(
                t('sideBarBids.title'),
                // @ts-ignore
                <BidsSideBarContainer nft={nft} lot={lot} />
            );
        },
        [render, t]
    );
};
